import CONFIG from '../../../../constants/config'

/**
 * 支付相关常量配置
 */
export const PAYMENT_CONFIG = {
  // 轮询配置
  POLLING: {
    DELAY: 3000, // 轮询间隔（毫秒）
    MAX_DURATION: 30 * 60 * 1000, // 最大轮询时间（30分钟）
    QR_INVALID_DURATION: 5 * 60 * 1000, // 二维码失效时间（5分钟）
    get MAX_COUNT() {
      return this.MAX_DURATION / this.DELAY
    },
    get INVALID_COUNT() {
      return this.QR_INVALID_DURATION / this.DELAY
    }
  },

  // 消息文本
  MESSAGES: {
    PAYMENT_SUCCESS: '支付成功!',
    QR_CODE_INVALID: '二维码已失效',
    ORDER_CREATING_BY_OTHERS: '其他成员正在创建订单',
    CLICK_TO_REFRESH: '点击刷新'
  },

  // 埋点配置
  SENSOR_TRACKING: {
    PAGE_TYPE: 'groupVIP',
    TRACK_SIGN: 'avip.b4363.action.web_click_page_workgroup_open_vip',
    REQUIREMENT_ID: 801
  }
} as const

/** 开通弹窗本体 .payment-refactor 为 1001（盖过业务 antd Modal），内部提示需再高一层 */
const ABOVE_PAYMENT_Z_INDEX = 1002

// 特定弹窗配置
export const MODAL_CONFIGS = {
  SVIP_RESTRICTION: {
    centered: true,
    title: '提示',
    okText: '我知道了',
    zIndex: ABOVE_PAYMENT_Z_INDEX
  },
  VVIP_RESTRICTION: {
    centered: true,
    title: '提示',
    content: '此权益为团队"高级会员"权益，购买基础会员无法享受此权益',
    okText: '我知道了',
    zIndex: ABOVE_PAYMENT_Z_INDEX
  },
  CUSTOMER_TIPS: {
    centered: true,
    // 不再传 transitionName：antd6 下该字段会覆盖默认 zoom 动效为 'fade'，
    // 而 antd6 已无 'fade' 过渡 CSS，导致 leave 动画 transitionend 永不触发、
    // Modal.info 点「我知道了」后无法卸载（弹框关不掉）。去掉后回落默认 zoom 正常关闭。
    title: '温馨提示',
    okText: '我知道了',
    zIndex: ABOVE_PAYMENT_Z_INDEX
  }
} as const

// 弹窗图标组件（需要在组件中使用时动态创建）
export const createModalIcon = () => {
  return { type: 'exclamation-circle' }
}

/**
 * 获取会员等级对应的埋点参数。
 *
 * @param vipKind - 后端下发的会员档位
 * @returns 神策埋点使用的会员等级标识
 *
 * @example
 * ```ts
 * getVipLevelForTracking(CONFIG.VIP_KIND.VVIP) // 'premiumVip'
 * getVipLevelForTracking(CONFIG.VIP_KIND.SVIP) // 'superVip'
 * ```
 */
export const getVipLevelForTracking = (vipKind: number) => {
  switch (vipKind) {
    case CONFIG.VIP_KIND.VVIP:
      return 'premiumVip'
    case CONFIG.VIP_KIND.SVIP:
      return 'superVip'
    default:
      return 'generalVip'
  }
}
